export default {
    topics: [
        {
            title: ' BuildQuery ',
            href: 'sm-queryDef-BuildQuery.html',
            attributes: { 'data-id': 'sm-queryDef-BuildQuery' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-BuildQuery-d66e1060',
            topics: [],
        },
        {
            title: ' BuildQueryEx ',
            href: 'sm-queryDef-BuildQueryEx.html',
            attributes: { 'data-id': 'sm-queryDef-BuildQueryEx' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-BuildQueryEx-d66e1068',
            topics: [],
        },
        {
            title: ' CreateInstanceFromModel ',
            href: 'sm-queryDef-CreateInstanceFromModel.html',
            attributes: { 'data-id': 'sm-queryDef-CreateInstanceFromModel' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-CreateInstanceFromModel-d66e1076',
            topics: [],
        },
        {
            title: ' DisplayCondition ',
            href: 'sm-queryDef-DisplayCondition.html',
            attributes: { 'data-id': 'sm-queryDef-DisplayCondition' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-DisplayCondition-d66e1084',
            topics: [],
        },
        {
            title: ' EvaluateExpr ',
            href: 'sm-queryDef-EvaluateExpr.html',
            attributes: { 'data-id': 'sm-queryDef-EvaluateExpr' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-EvaluateExpr-d66e1092',
            topics: [],
        },
        {
            title: ' ExecuteQuery ',
            href: 'sm-queryDef-ExecuteQuery.html',
            attributes: { 'data-id': 'sm-queryDef-ExecuteQuery' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-ExecuteQuery-d66e1100',
            topics: [],
        },
        {
            title: ' GetInstanceFromModel ',
            href: 'sm-queryDef-GetInstanceFromModel.html',
            attributes: { 'data-id': 'sm-queryDef-GetInstanceFromModel' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-GetInstanceFromModel-d66e1108',
            topics: [],
        },
        {
            title: ' SelectAll ',
            href: 'sm-queryDef-SelectAll.html',
            attributes: { 'data-id': 'sm-queryDef-SelectAll' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-SelectAll-d66e1116',
            topics: [],
        },
        {
            title: ' Update ',
            href: 'sm-queryDef-Update.html',
            attributes: { 'data-id': 'sm-queryDef-Update' },
            menu: { hasChildren: false },
            tocID: 'sm-queryDef-Update-d66e1124',
            topics: [],
        },
    ],
};

